module.exports = __webpack_public_path__ + "img/box3_img4_active.4c1074e5.png";